import React from 'react';

import { Tr } from '@chakra-ui/react';
import styled from '@emotion/styled';

const BodyTr = styled(Tr)`
  // background: ${(props) => props.theme.colors.common.white};
  border-bottom: 1px solid ${(props) => props.theme.colors.neutral.CFD7DF};
  &:hover {
    background: ${(props) => props.theme.colors.neutral.F6FAFE};
  }
  & td {
    border-bottom: 0;
  }
`;

const TableBodyRow = ({ children, ...props }) => (
  <BodyTr bg="common.white" {...props}>
    {children}
  </BodyTr>
);

export { TableBodyRow };
